import { HorizontalContainer } from '@picsart/design-system/components/HorizontalContainer';
import classNames from 'classnames';
import { ReactNode } from 'react';
import useStyles from './styles';

interface HorizontalContainerWrapperProps {
  children: ReactNode;
  className?: string;
}

function HorizontalContainerWrapper({ children, className = '' }: HorizontalContainerWrapperProps) {
  const styles = useStyles();
  return (
    <HorizontalContainer className={classNames(styles.horizontalContainerWrapper, className)}>
      {children}
    </HorizontalContainer>
  );
}

HorizontalContainerWrapper.defaultProps = {
  className: '',
};

export default HorizontalContainerWrapper;
